var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "correct (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1425.000000, -175.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "correct-(1)",
    transform: "translate(1425.000000, 175.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0 C7.85011295,0 0,7.85011295 0,17.5 C0,27.1498871 7.85011295,35 17.5,35 C27.1498871,35 35,27.1498871 35,17.5 C35,7.85011295 27.1498871,0 17.5,0 Z",
    id: "Path",
    fill: "#286EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3704495,13.709778 L16.9167851,23.2232742 C16.6331672,23.5086953 16.2608688,23.6523438 15.8885703,23.6523438 C15.5162718,23.6523438 15.1439734,23.5086953 14.8603555,23.2232742 L10.1336565,18.4665261 C9.56482283,17.8943442 9.56482283,16.969205 10.1336565,16.3970231 C10.7022238,15.8245732 11.6212524,15.8245732 12.1900861,16.3970231 L15.8885703,20.1190197 L24.3140198,11.640275 C24.8825872,11.067825 25.8016158,11.067825 26.3704495,11.640275 C26.9390168,12.2124569 26.9390168,13.137328 26.3704495,13.709778 Z",
    id: "Path",
    fill: "#FAFAFA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.72c121550bb930b3ba5b6a24908d22ac.svg";
export { ForwardRef as ReactComponent };